// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__kExXF","label":"Radio_label__2OBZ5","checkMark":"Radio_checkMark__2gtkc","disabled":"Radio_disabled__1Knu_"};